import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Rails from 'rails-ujs'
Rails.start()

import 'errorReporting'
import 'bootstrap'
import 'styles'
